var cansearch = true;
var loaders = new Array;

function appendLoader(loadername) {
    loaders[loaders.length] = loadername;
}

/* Fix for IE window.location issues */
window.MSStream && window.addEventListener("DOMContentLoaded", function () {
    var base = document.getElementsByTagName('base')[0].href,
        links = document.getElementsByTagName('a');
    for (var l = links.length, i = 0; l > i; i++) {
        var a = links[i], href = a.getAttribute("href");
        if (href && href.indexOf('http') !== 0 && href.indexOf('/') !== 0) {
            a.setAttribute("href", base + href);
        }
    }
});

$.extend($.fn, {
    slideToElement: function (target) {
        var $target = $('a[name=' + target + ']');
        if ($target.length) {
            var targetOffset = $target.offset().top;
            $('html,body').animate({
                scrollTop: targetOffset - 100
            }, 500, 'linear', function () {
            });
            return false;
        }
    },
    addLoader: function () {
        var elm = this[0],
            offsetParent = elm.offsetParent || document.body,
            totalWidth = this.outerWidth(),
            totalHeight = this.outerHeight(),
            position, anchor, anchor_pos;

        if(!this.length){
            return;
        }

        if(['TD', 'TH', 'TABLE'].indexOf(offsetParent.tagName) > -1
            && $(offsetParent).css('display').indexOf('table') === -1){
            //position is invalid when table display is changed

            anchor = this.add(this.parents()).filter(function () {
                return $(this).css("position") === "relative" || this.tagName === 'body'
            }).eq(0);
            anchor_pos = anchor.offset()
            position = this.offset();

            position.left -= anchor_pos.left;
            position.top -= anchor_pos.top;
        }else{
            anchor = this;
            position = this.position();
        }

        var preloader = $('#preloader');
        if (preloader.length > 0) {
        } else {
            preloader = $('<div id="preloader" ></div>');
        }

        preloader.css({
            position: 'absolute',
            top: position.top,
            left: position.left,
            width: totalWidth,
            height: totalHeight
        });

        preloader.show();
        preloader.appendTo(anchor);
    },
    TabbedMenu: function (o) {
        var el = o != undefined && o.elem != undefined ? o.elem : '.tabb';
        var num = o != undefined && o.num != undefined ? o.num : 0;
        $(el).hide();
        $(el).eq(num).show();
        $('a.tchoice').eq(num).addClass('picked');

        $(this).find('a.tchoice').each(function (n) {
            $(this).click(function () {
                $(el).hide();
                $(el).eq(n).show();
                $('a.tchoice').removeClass('picked');
                $(this).addClass('picked');
                return false;
            });
        });
        return ($(this));
    },
    ajaxHint: function () {
        $(this).each(function () {
            $(this).keyup(function () {
                if (cansearch) {
                    if ($(this).val() != '' && $(this).val() != ' ') {
                        cansearch = false;
                        $.post('?cmd=tickets&action=kbhint', {
                            query: $(this).val()
                        }, function (data) {
                            cansearch = true;
                            var resp = parse_response(data);
                            if (resp !== false && typeof(resp) == 'string' && resp != '') {
                                $('#hintarea').html(resp).slideDown();
                            }
                        });
                    } else {
                        $('#hintarea').html('').slideUp('fast');
                    }
                }
            });
        });
    }
});

function isEmpty(obj) {
    if (typeof obj == "string") {
        if (obj.length > 0)
            return false;
    }
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop))
            return false;
    }
    return true;
}

function ajax_update(url, params, update, swirl) {
    if (swirl)
        $(update).html('<span class="text-center"><img src="ajax-loading.gif" /></span>');

    if (params != undefined && isEmpty(params)) {
        params = {
            empty1m: 'param'
        };
    }
    $.post(url, params, function (data) {
        var resp = parse_response(data);
        if (!resp) {
            $(update).html('');
            return false;
        }
        else {
            $(update).html(resp).trigger('ajaxupdate');
        }
    });
}

function getParameterByName(name, data) {
    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(data || window.location.search);
    if (results == null)
        return "";
    else
        return decodeURIComponent(results[1].replace(/\+/g, " "));
}

function parse_response(data) {
    if (data.indexOf('<!-- {') != 0)
        return false;

    var codes = eval('(' + data.substr(data.indexOf('<!-- ') + 4, data.indexOf('-->') - 4) + ')');
    // alert(codes.ERROR);
    var i = 0;

    for (i = 0; i < codes.ERROR.length; i++) {
        new PNotify({
            text: codes.ERROR[i],
            type: 'error',
            hide: false,
            sticker: false,
            icon: false,
            buttons: {
                sticker: false
            }
        });
    }

    for (i = 0; i < codes.INFO.length; i++) {
        new PNotify({
            text: codes.INFO[i],
            type: 'info',
            hide: false,
            sticker: false,
            icon: false,
            buttons: {
                sticker: false
            }
        });
    }
    if (codes.EVAL) {
        for (i = 0; i < codes.EVAL.length; i++) {
            eval(codes.EVAL[i]);
        }
    }
    return data.substr(data.indexOf('-->') + 3, data.length);
}

function pagination_li(page) {
    if (typeof page == "undefined") {
        page = 1;
    } else if (page == -1) {
        page = 1;
    }
    var that = $(this),
        max = parseInt(that.attr('rel')) + 1,
        pages = [1],
        html = [];
    that.find('.page-li').remove();

    var htl = pages.length;
    for (var i = 1; i < max; i++) {
        var act = i == page ? 'active ' : '';
        html.push('<li class="' + act + 'page-li page-item"><a class="page-link" href="#' + i + '" onclick="return false;">' + i + '</a></li>');
    }
    that.children().unbind('click').click(function () {
        var that = $(this),
            page = parseInt($('#currentpage').val()),
            max = parseInt(that.parent('ul').attr('rel'));
        if (that.is('.page-item-left') && page > 0)
            $('#currentpage').val(page - 1).change();
        else if (that.is('.page-item-right') && page + 1 < max)
            $('#currentpage').val(page + 1).change();
        return false;
    }).eq(0).after(html.join('')).end().end().find('.page-li a').each(function () {
        if (!$(this).parent().is('.active')) {
            $(this).click(function () {
                if ($(this).attr('href')) {
                    var p = parseInt($(this).attr('href').substr(1));
                    pagination_li.call(that, p);
                    $('#currentpage').val(p - 1).change();
                }
                return false;
            });
        }
    });
}

function sorterUpdate(low, high, total, pages) {
    $('ul[rel].pagination ').each(function () {
        var self = $(this);
        self.attr('rel', pages);
        pagination_li.call(this, self.find('.active').index());
    });
}

$(document).ready(function () {
    function CSRFProtection(xhr) {
        var token = $('meta[name="csrf-token"]').attr('content');
        if (token)
            xhr.setRequestHeader('X-CSRF-Token', token);
    }

    if ('ajaxPrefilter' in $)
        $.ajaxPrefilter(function (options, originalOptions, xhr) {
            CSRFProtection(xhr)
        });
    else
        $(document).ajaxSend(function (e, xhr) {
            CSRFProtection(xhr)
        });

    $(".vtip_description").tooltip();
    $('.sh1a .orderboxpadding').click(function () {
        var e = $(this).parent().find('.subdesc_').eq(0);
        if ($(e).is(':visible')) {
            $(e).hide();
        } else {
            $(e).show();
        }
    });

    $("a.sortorder").click(function () {
        $('#updater').addLoader();
        $('#checkall').attr('checked', false);
        $('#currentlist').attr('href', $(this).attr('href'));

        if ($(this).attr('href').substring($(this).attr('href').lastIndexOf('|')) == '|ASC') {

            $(this).attr('href', $(this).attr('href').substring(0, $(this).attr('href').lastIndexOf('|')) + '|DESC');
        }
        else {

            $(this).attr('href', $(this).attr('href').substring(0, $(this).attr('href').lastIndexOf('|')) + '|ASC');
        }

        ajax_update($('#currentlist').attr('href'), {
            page: $('#currentpage').val(),
            layer: 'ajax'
        }, '#updater');
        return false;
    });

    $('#pageswitch button').click(function () {
        var p = parseInt($(this).text()) - 1;
        $('#currentpage').val(p).change();
        return false;
    });

    $('ul[rel].pagination ').each(function () {
        pagination_li.call(this);
        //$('#currentpage').val(p).change();
    });

    $('#currentpage').change(function () {
        $('#updater').addLoader();
        $('#checkall').attr('checked', false);
        ajax_update($('#currentlist').attr('href'), {
            page: $('#currentpage').val(),
            layer: 'ajax'
        }, '#updater');
    });

    $(document).ajaxSend(function (a, b, c) {
        var page = parseInt(getParameterByName('page', '?' + c.data));
        if (!isNaN(page))
            $('ul[rel].pagination ').each(function () {
                pagination_li.call(this, page + 1);
            });
    });

    $('.submiter').click(function () {
        $('#updater').addLoader();
        $('#checkall').attr('checked', false);
        var pushs = '';
        if ($(this).attr('queue'))
            pushs = 'push';
        ajax_update($('#currentlist').attr('href') + '&' + $('#testform').serialize() + '&' + $(this).attr('name'), {
            layer: 'ajax',
            stack: pushs
        }, '#updater');
        return false;
    });

    setTimeout(function () {
        if ($('#errors').find('span').length > 0) {
            $('#errors').slideDown();
        }
        if ($('#infos').find('span').length > 0) {
            $('#infos').slideDown();
        }
    }, 30);

    if (loaders.length > 0) {
        var i = 0;
        for (i = 0; i < loaders.length; i++) {
            if (loaders[i] == 'flyingSidemenu')
                continue;
            eval(loaders[i] + '()');
        }
    }
    (function ($) {
        var e = 0;
        var w = 100;
        var u = $('.pa1 a', '#submenu');
        var l = u.length;
        u.each(function (o) {
            if (e == 0 && $(this).width() + $(this).position().left > 960) {
                e = o;
            }
            if ($(this).width() > w)
                w = $(this).width();
        });
        if (e > 0) {
            var d = $('<ul class="dropdown-menu"></ul>');

            var a = $('<a class="dropdown-toggle" data-toggle="dropdown" href="#"></a>').text('More').append($('<b class="caret"></b>'));
            var more = $('<li class="dropdown"></li>').append(a);
            for (i = l; i >= e; i--) {
                d.prepend(u.eq(i));
            }
            more.append(d);
            $('.pa1', '#submenu').append(more);

        }

    })(jQuery);

    var $win = $(window)
        , $nav = $('#mainmenu')
        , navTop = $('#mainmenu').length && $('#mainmenu').offset().top
        , isFixed = 0

    wrapIcons();
    if ($('#cart').length && $('#sidemenu').length && $('#floater').length)
        $win.on('scroll', processScroll2);

    function processScroll2() {
        var t = $(window).scrollTop() - $('#sidemenu').offset().top;
        var maxi = $('#cart').height() - $('#floater').height() - 15;
        if (t > maxi)
            t = maxi;
        if (t < 0)
            t = 0;
        if ($('#mainmenu').hasClass('nav-fixed'))
            t += 60;

        $('#floater').animate({
            top: t + "px"
        }, {
            queue: false,
            duration: 300
        });
    }

    $('#ticketmessage').ajaxHint();
});


function wrapIcons() {
    var v = $.browser.version.substring(0, $.browser.version.indexOf('.'));

    // IE7 support
    if ($.browser.msie && v == "7") {
        // Icons replacement map
        var iconMap = {
            'phone': '!',
            'mobile': '"',
            'tag': '#',
            'directions': '$',
            'mail': '%',
            'pencil': '&',
            'paperclip': '\'',
            'reply': '(',
            'replay-all': ')',
            'forward': '*',
            'user': '+',
            'users': ',',
            'add-user': '-',
            'card': '.',
            'extract': '/',
            'marker': '0',
            'map': '1',
            'compass': '2',
            'arrow': '3',
            'target': '4',
            'path': '5',
            'heart': '6',
            'star': '7',
            'like': '8',
            'chat': '9',
            'speech': ':',
            'quote': ';',
            'printer': '<',
            'bell': '=',
            'link': '>',
            'flag': '?',
            'gear': '@',
            'flashlight': 'A',
            'cup': 'B',
            'price-tag': 'C',
            'camera': 'D',
            'moon': 'E',
            'palette': 'F',
            'leaf': 'G',
            'music-note': 'H',
            'bag': 'I',
            'plane': 'J',
            'buoy': 'K',
            'rain': 'L',
            'eye': 'M',
            'clock': 'N',
            'mic': 'O',
            'calendar': 'P',
            'lightning': 'Q',
            'hourglass': 'R',
            'rss': 'S',
            'wifi': 'T',
            'lock': 'U',
            'unlock': 'V',
            'tick': 'W',
            'cross': 'X',
            'minus-round': 'Y',
            'plus-round': 'Z',
            'cross-round': '[',
            'minus': '\\',
            'plus': ']',
            'forbidden': '^',
            'info': '_',
            'info-round': '`',
            'question': 'a',
            'question-round': 'b',
            'warning': 'c',
            'redo': 'd',
            'undo': 'e',
            'swap': 'f',
            'revert': 'g',
            'refresh': 'h',
            'list': 'i',
            'list-add': 'j',
            'thumbs': 'k',
            'page-list': 'l',
            'page': 'm',
            'pages': 'n',
            'marker': '0',
            'pictures': 'p',
            'movie': 'q',
            'music': 'r',
            'folder': 's',
            'drawer': 't',
            'trash': 'u',
            'outbox': 'v',
            'inbox': 'w',
            'download': 'x',
            'cloud': 'y',
            'cloud-upload': 'z',
            'play': '{',
            'pause': '|',
            'record': '~',
            'forward': 'Ä',
            'backward': 'Å',
            'previous': 'Ç',
            'next': 'É',
            'expand': 'Ñ',
            'reduce': 'Ö',
            'volume': 'Ü',
            'loud': 'á',
            'mute': 'à',
            'left-fat': 'â',
            'down-fat': 'ä',
            'up-fat': 'ã',
            'right-fat': 'å',
            'left': 'ç',
            'down': 'é',
            'up': 'è',
            'right': 'ê',
            'left-round': 'ë',
            'down-round': 'í',
            'up-round': 'ì',
            'right-round': 'î',
            'home': 'ï',
            'ribbon': 'ñ',
            'read': 'ó',
            'new-tab': 'ò',
            'search': 'ô',
            'ellipsis': 'ö',
            'bullet-list': '®',
            'creative-commons': '©'
        };


        // Font-icons
        $('[class^="iconfont-"],[class*=" iconfont-"]').each(function (i) {
            // Icon class
            var name = /iconfont-([^ ]+)/.exec(this.className)[1],
                element = $(this);
            // If valid icon name
            if (iconMap[name]) {
                // Create replacement
                element.prepend('<span class="font-icon' + (element.is(':empty') ? ' empty' : '') + '">' + iconMap[name] + '</span>');
            }
        });
    }
    // IE8 support
    if ($.browser.msie && parseInt(v) == 8) {
        // Font-icons
        $('[class^="iconfont-"],[class*=" iconfont-"]').each(function (i) {
            // Empty elements
            var element = $(this);
            if (element.is(':empty')) {
                element.addClass('font-icon-empty');
            }
        });
    }
    ;
}
